
import '../../../styles/style.css';
import React, { useState, useEffect,useRef } from 'react';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';


import useFetch from '../../api/useFetch';
import { Loader } from '@progress/kendo-react-indicators';
const DATA_ITEM_KEY = 'id';

const Aniversario= () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  const gridRef = useRef(null);
  const [query, setQuery] = useState("");
  const { data: empleados = [], isLoading } = useFetch("api/Empleados/Aniversario");
  const empleadosData = (empleados || []).map(e => ({
    ...e
  }));

  const filteredData = empleadosData.filter(emp =>
    JSON.stringify(emp).toLowerCase().includes(query.toLowerCase())
  );

 useEffect(() => {
     const onResize = () => setIsMobile(window.innerWidth < 768);
     window.addEventListener('resize', onResize);
   
     const gridElement = gridRef.current;
     if (!gridElement) return;
   
     const content = gridElement.querySelector('.k-grid-content');
     if (!content) return;
   
     let animationId;
     const speed = 1;       // velocidad del scroll
     let direction = 1;     // 1 = abajo, -1 = arriba
     let isPaused = false;  // pausa por interacción
   
     const autoScroll = () => {
       if (!isPaused) {
         content.scrollTop += speed * direction;
   
         if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
           direction = -1;
         }
   
         if (content.scrollTop <= 0) {
           direction = 1;
         }
       }
   
       animationId = requestAnimationFrame(autoScroll);
     };
   
     const pauseScroll = () => (isPaused = true);
     const resumeScroll = () => (isPaused = false);
   
     // Eventos de interacción
     content.addEventListener('mouseenter', pauseScroll);
     content.addEventListener('wheel', pauseScroll);
     content.addEventListener('mousedown', pauseScroll);
     content.addEventListener('mouseleave', resumeScroll);
   
     animationId = requestAnimationFrame(autoScroll);
   
     return () => {
       cancelAnimationFrame(animationId);
       window.removeEventListener('resize', onResize);
   
       content.removeEventListener('mouseenter', pauseScroll);
       content.removeEventListener('wheel', pauseScroll);
       content.removeEventListener('mousedown', pauseScroll);
       content.removeEventListener('mouseleave', resumeScroll);
     };
   }, [filteredData.length]);
const CenteredHeader = (props) => (
  <span style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
    {props.title}
  </span>
);

  if (isLoading) {
    return (
      <div className="h-[370px] flex justify-center items-center">
        <Loader size="large" type="infinite-spinner" />
      </div>
    );
  }

  return (
<div className="grid-aniversario-container" ref={gridRef}>
    {/* GRID */}
      <Grid
        className="aniversario-grid"
        dataItemKey={DATA_ITEM_KEY}
        data={filteredData}
        scrollable={'scrollable'}
        resizable={true}
        style={{width: '100%',margin: 'auto'}}
      >
                <Column field="nombreCompleto"title="Empleado"/>
                <Column field="añosCumplidos" title="Años" className="añosCum" />  
      </Grid>
</div>

 );
};

export default Aniversario;
